import React from 'react';
import CurrencyItem from '../Domain/CurrencyItem';
import AuthService from './authService.js';
import CurrencyAdminItems from '../Domain/CurrencyAdminItem';
import CurrencyDetailsItem from '../Domain/CurrencyDetailsItem';
import CurrencyAdminItem from '../Domain/CurrencyAdminItem';
import SearchParams from '../Elements/SearchParams';
import CurrencySearchParams from '../Contents/Currency/CurrencyAdmin/CurrencySearchParams';

class CurrencyService extends React.Component {
  static async GetCurrencyList() {
    return AuthService.getInstance().CallBackendFunction('/api/Currency/?clearCache=false');
  }

  static async GetCurrencyListWithDetails(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, CurrencySearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Currency/GetGlobalDataCurrencies?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetGlobalDataCurrencies(id) {
    const url = `/api/Currency/GetCurrencyDetails/${id}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async UpsertCurrency(input) {
    const currency = CurrencyAdminItem.CreateEditedCurrencyJSONObject(input);

    if (input.CurrencyId === '') {
      const url = `/api/Currency/SaveCurrency/`;
      return CurrencyService.AddNewCurrency(url, currency);
    } else if (parseInt(input.CurrencyId) !== undefined && parseInt(input.CurrencyId) > 0) {
      const url = `/api/Currency/EditCurrency/`;
      return CurrencyService.EditCurrency(url, currency);
    }
    return;
  }

  static async EditCurrency(currency) {
    const url = '/api/Currency/EditCurrency/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, currency);
  }

  static async AddNewCurrency(url, currency) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, currency);
  }

  static async GetCurrencyById(id) {
    const currencyList = await CurrencyService.GetCurrencyList();
    return currencyList.find((c) => c.CurrencyId === id);
  }

  static async GetCurrencyNameById(id) {
    id = id ? id : 0;
    const url = `/api/Currency/GetCurrencyNameById/${id}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetCurrencyCodeById(id) {
    const url = `/api/Currency/GetCurrencyCodeById/${id}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBDetails(item) {
    if (item !== null) return new CurrencyDetailsItem(item);
    return [];
  }

  static ConvertDBCurrencyDetails(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CurrencyAdminItems(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertDBCurrency(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CurrencyItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}

export default CurrencyService;
